<span class="label" :class="getClass">{{ getRegelsatzStatusLabelKbez }}</span>